import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import type { NotificationDto } from '@cardhub/protocol';
import { api } from '../api/client';
import { Empty, ErrorState, Loading, TopBar } from '../components/ui';
import { useFormat, useT } from '../i18n';
import { useAsync } from '../lib/hooks';
import { useSession } from '../store/session';

const ICON: Record<string, string> = {
  friend_request: '🤝',
  friend_accepted: '🎉',
  room_invite: '🃏',
  mission_completed: '🎯',
  achievement_unlocked: '🏅',
  level_up: '⭐',
  tournament_started: '🏆',
  tournament_result: '🏆',
  referral_reward: '🎁',
  recovery_refund: '↩️',
  chat_muted: '🔇',
};

export function Notifications() {
  const t = useT();
  const f = useFormat();
  const nav = useNavigate();
  const list = useAsync(() => api.get<{ items: NotificationDto[]; unread: number }>('/api/v1/notifications'), []);
  useEffect(() => {
    if (list.data && list.data.unread > 0) {
      void api.post('/api/v1/notifications/read', { ids: 'all' }).then(() => useSession.setState({ unread: 0 }));
    }
  }, [list.data]);
  const open = (n: NotificationDto) => {
    const d = n.data as { code?: string; tableId?: string; userId?: string };
    if (n.type === 'room_invite' && d.code) nav(`/rooms/${d.code}`);
    else if (n.type === 'friend_request') nav('/friends');
    else if (n.type === 'mission_completed') nav('/rewards?tab=missions');
    else if (n.type === 'tournament_started' && d.tableId) nav(`/table/${d.tableId}`);
  };
  return (
    <main className="page">
      <TopBar title={t('notif.title')} onBack={() => nav(-1)} />
      {list.loading && <Loading />}
      {list.error && <ErrorState message={list.error} onRetry={list.reload} />}
      {list.data?.items.length === 0 && <Empty emoji="🔔" title={t('notif.empty')} />}
      <div className="list">
        {list.data?.items.map((n) => (
          <button key={n.id} className="list-item" onClick={() => open(n)} style={{ fontWeight: n.read ? 400 : 700 }}>
            <span style={{ fontSize: 26 }} aria-hidden>{ICON[n.type] ?? '🔔'}</span>
            <span className="grow">
              {n.title}
              <br />
              <span className="muted" style={{ fontSize: 'var(--fs-sm)', fontWeight: 400 }}>{n.body}</span>
            </span>
            <span className="muted" style={{ fontSize: 'var(--fs-xs)' }}>{f.relative(n.createdAt)}</span>
          </button>
        ))}
      </div>
    </main>
  );
}
